package com.rosario.juridico.platform

import com.rosario.juridico.domain.model.MediacionGasto
import kotlinx.browser.window

class JsDocumentExporter : DocumentExporter {
    override fun compartirPlanilla(gasto: MediacionGasto) {
        val texto = generarTextoPlanilla(gasto)
        if (window.navigator.asDynamic().share != null) {
            window.navigator.asDynamic().share(js("{text: texto}"))
        } else {
            window.alert("Compartir no disponible. Texto copiado al portapapeles.")
            window.navigator.clipboard.writeText(texto)
        }
    }

    override fun imprimirPlanilla(gasto: MediacionGasto) {
        // En la web, imprimir suele ser imprimir toda la página o abrir un modal imprimible
        window.print()
    }

    override fun exportarPDF(gasto: MediacionGasto) {
        // En la web, PDF suele ser window.print() y que el usuario elija "Guardar como PDF"
        // O usar una librería pesada. Por simplicidad, usamos print.
        window.print()
    }

    override fun enviarWhatsApp(gasto: MediacionGasto) {
        val texto = generarTextoPlanilla(gasto)
        val encoded = js("encodeURIComponent(texto)") as String
        val url = "https://wa.me/?text=$encoded"
        window.open(url, "_blank")
    }

    private fun generarTextoPlanilla(gasto: MediacionGasto): String {
        return """
            PLANILLA DE GASTOS DE CIERRE DE MEDIACIÓN
            ------------------------------------------
            Nro. Mediación: ${gasto.nroMediacion}
            Fecha: ${gasto.fechaFormulario}
            
            Mediador: ${gasto.mediadorNombre}
            Matrícula: ${gasto.mediadorMatricula}
            
            DETALLE ECONÓMICO:
            - Honorarios: $ ${gasto.honorariosPesos}
            - Gastos Admin: $ ${gasto.gastosAdministrativosPesos}
            - Aportes Caja: $ ${gasto.aportesPesos}
            ${if (gasto.cartasDocumento.isNotEmpty()) "- Cartas Documento: $ ${gasto.cartasDocumento.sumOf { it.monto }}" else ""}
            
            TOTAL A ABONAR: $ ${gasto.totalPesos}
            
            DATOS DE PAGO:
            Alias: ${gasto.pagoAlias}
            CBU: ${gasto.pagoCbu}
            Banco: ${gasto.pagoBanco}
            
            Documento meramente informativo no constituyendo factura ni recibo.
        """.trimIndent()
    }
}

actual fun getDocumentExporter(): DocumentExporter = JsDocumentExporter()
